import { useState, useEffect } from "react";
import { CustomProperty } from "winslow-core";
import { GenericSelect, GenericSelectOption } from "../../shared/GenericSelect";
import { AppCustomPropertyError } from "./AppCustomPropertyError";

type AppCustomPropertyRadioProps = {
    customProperty: CustomProperty;
    data: any;
    disabled: boolean;
    validate: boolean
    onChange: (label: string, data: any) => void;
}

export const AppCustomPropertyRadio = ({customProperty, data, disabled, validate, onChange} : AppCustomPropertyRadioProps) => {

    const [choice, setChoice] = useState<string>(data || JSON.parse(customProperty.settings || "{}").default || "");

    useEffect(() => {
        const defaultChoice = JSON.parse(customProperty.settings || "{}").default || "";
        console.log("[AppCustomPropertyRadio] setting default choice: ", defaultChoice);

        setChoice(defaultChoice);
        // alert("setting default choice: " + defaultChoice);
        onChange(customProperty.label, defaultChoice);
    }, []);

    useEffect(() => {
        console.log("[AppCustomPropertyRadio] choice: ", choice);
        onChange(customProperty.label, choice);
    }, [choice, customProperty]);

    const settings = JSON.parse(customProperty.settings || "{}");
    
    const sortedChoices = settings.alphabetize ? settings.choices.sort((a: string, b: string) => a.localeCompare(b)) : settings.choices;
    
    return (
        <div className="app-custom-property-radio">
        
            {sortedChoices.map((option: string, index: number) => {
                return (
                    <div 
                        key={"radio-" + index}
                        className="app-custom-property-radio-choice"
                    >
                        <input 
                            type="radio"
                            disabled={disabled}
                            name={customProperty.label}
                            checked={choice === option}
                            onChange={(event) => {
                                setChoice(option);
                            }}
                        />
                        {option}
                    </div>
                )
                })
            }
            <AppCustomPropertyError 
                flagRequired={validate && !choice && customProperty.required}
            />
            
        </div>
    )
}
